import React, { useEffect,useState,createRef } from 'react';
import { Button, Modal } from 'react-bootstrap';
import {useTranslation} from 'react-i18next';
import NumberFormat from 'react-number-format';
import {toast} from 'react-toastify';
import {useFormik} from 'formik';
import * as Yup from 'yup';
import CustomSelect from '../../components/custom-select/CustomSelect';
import AlertDialog from '../../components/alert-dialog/AlertDialog';
import DatePicker, { registerLocale, setDefaultLocale } from "react-datepicker";
import moment from 'moment';
import ArticlePartModalWithDatatable from '../bom/ArticlePartModalWithDatatable';
import * as RestService from '../../services/eisRest';





  const UsedBomModal = (props) => {

   

    const [t] = useTranslation();      
    const [isOpen, setIsOpen] = useState(false);
    
    const [selectedRecord, setSelectedRecord] = useState();
    const [entityId, setEntityId] = useState();
  
    const [workOrderItemBom, setWorkOrderItemBom] = useState([]);
      
    const [openAlertDialog, setOpenAlertDialog] = useState(false);
    const [validFromLong, setValidFromLong] = useState(new Date());
    const [validToLong, setValidToLong] = useState(new Date());
    const dialogRef = createRef();
    const [showArticlePartModalWithDatatable, setShowArticlePartModalWithDatatable] = useState(false);
    const [loadedArticlePart, setLoadedArticlePart] = useState();
    const [loadedMeasureUnit,setLoadedMeasureUnit] = useState('');

    
    const [qty, setQty ] = useState(0); 
    const [maxQty, setMaxQty ] = useState(0);    
    const [maxQtyBasic, setMaxQtyBasic ] = useState(0);    
    const [reservedQty, setReservedQty ] = useState(0);    
    
    const [bomItemId, setBomItemId ] = useState(null);    
    const [workOrderId, setWorkOrderId ] = useState(null);    
    const [operationId, setOperationId ] = useState(null);    
    const [bomId, setBomId ] = useState(null);   

    const handleOpenArticleList = () => {
      setShowArticlePartModalWithDatatable(true);
    }

    const handleCallback = (show,id) => {         
      setShowArticlePartModalWithDatatable(show);             
      getDataAboutArticlePart(id);
    };
    
  
    const hideModal = () => {
      setIsOpen(false);
      showChanged(false);
    };

    const showChanged = (newStatus) => {
      props.parentCallback(newStatus);
    }
    
    const deleteRecord = () => {
      setOpenAlertDialog(true);
    };

    useEffect(() => {
      formik.resetForm();
      setIsOpen(props.modal);
      showChanged(props.modal);

    }, [props.modal])


    useEffect(() => {
      setWorkOrderId(props.workOrderId);
  }, [props.workOrderId])

    useEffect(() => {
      setOperationId(props.operationId);
  }, [props.operationId])

    useEffect(() => {
      setBomId(props.bomId);
  }, [props.bomId])

  

  const getDataAboutArticlePart = (id) => {
    RestService.callAnyApi('workOrder/getBomItem?bomId='+bomId+"&itemId="+id, null)
    .then((data) => {
      setBomItemId(data.id);
      setLoadedArticlePart(data.articlePart);
      setLoadedMeasureUnit(data.articlePart ? data.articlePart.measureUnit : '');
      formik.setFieldValue("name",data.articlePart ? data.articlePart.name : '');      
      setMaxQtyBasic(data.qty);
      getReservedQty(workOrderId,operationId,data.id);
      setValidFromLong(data.validFromLong);
      setValidToLong(data.validToLong);
    })
    .catch((error) => {
      console.log(error);
    });
  }

  const getReservedQty = (workOrderId,workOrderItem,bomItemId) => {
    RestService.callAnyApi('workOrder/getReservedQty?workOrderId='+workOrderId+"&workOrderItem="+workOrderItem+"&bomItemId="+bomItemId, null)
    .then((data) => {
      setReservedQty(data); 
    //  setMaxQty(maxQtyBasic-data);    
    })
    .catch((error) => {
      console.log(error);
    });
  }

  useEffect(() => {          
    setMaxQty(maxQtyBasic-reservedQty);    
  }, [maxQtyBasic])

  useEffect(() => {          
    setMaxQty(maxQtyBasic-reservedQty);    
  }, [reservedQty])


    useEffect(() => {      
      setSelectedRecord(props.selectedRecord);
      RestService.callAnyApi('workOrder/getWorkOrderItemBom?id='+props.selectedRecord, null)
      .then((data) => {           
           setWorkOrderItemBom(data);      
           setLoadedArticlePart(data.article);
           setLoadedMeasureUnit(data.article ? data.article.measureUnit : '');
           formik.setFieldValue("name",data.article ? data.article.name : '');
           
           setQty(data.qty);   
           getReservedQty(workOrderId,operationId,data.bomItemId);
           getDataAboutArticlePart(data.bomItemId);
      })
      .catch((error) => {
        console.log(error);
      });

    }, [props.selectedRecord])

  
    useEffect(() => {      
      setEntityId(props.entityId);
    }, [props.entityId])

   
    const handleChange = (e,elementName) => {
      
      
          switch(elementName){              
              case "qty":
                  setQty(e.floatValue);    //number                   
              break;             
          }
      
    }

    const handleAlertDialogCallback = (clickedValue) => {
      setOpenAlertDialog(false);
      if(clickedValue==='OK'){
        RestService.callAnyApi('basic/deleteRecord?entity=workOrderItemBom&id='+props.selectedRecord, null).then(
          (data) => {
            hideModal();
          })
          .catch((error) => {
            console.log(error);
          });
      }
      
    }
    

    
    const showError = (error,serverMessage) =>{
      if(serverMessage==null){
          toast.error(
            (error.response &&
                error.response.data &&
                error.response.data.message &&
                error.responseMessage) ||
                t('general.message.failed')
          );
        }else{
          toast.error(serverMessage);
        }
    }

    const save = (url,values) => {
     
      if(qty>maxQty){
        showError(null,t('general.message.maximumQtyExceeded')) ;
        return;
      }

     workOrderItemBom.bomItemId = bomItemId;
     workOrderItemBom.workOrderId = workOrderId;
     workOrderItemBom.workOrderItemId = operationId;
     workOrderItemBom.articleId = loadedArticlePart ? loadedArticlePart.id : '';
     workOrderItemBom.qty = qty;

      RestService.callAnyApi(url,workOrderItemBom)
          .then((data) => {                                                 
                      if(data.responseMessage==='OK'){
                          toast.success(t('general.message.saveSucceed'));                                              
                          hideModal();
                      }else{
                          showError(null,data.responseMessage);
                      }
                  
                 
          })
          .catch((error) => {               
            showError(error,null);
          });
    };

    const formik = useFormik({
      enableReinitialize: true,
      initialValues: {    

        name : workOrderItemBom && workOrderItemBom.article ?  workOrderItemBom.article.name : ''  
       // bankId: articlePart.bankId || "",
       // currency: articlePart.currency || "",
       // departmentId: articlePart.departmentId || "",
       // iban: articlePart.iban || "",
      },
      validationSchema: Yup.object({
      //   bankId: Yup.string()     
      //    .required(t('general.message.required')),
       //   currency: Yup.string()     
       //   .required(t('general.message.required')),
        //  iban: Yup.string()     
         // .required(t('general.message.required')),
      }),
      onSubmit: (values) => {           
          save('workOrder/saveWorkOrderItemBom',values);         
      }
    });

    return (
      <>    
        <div className="modal-container">
                  <Modal
                    show={isOpen}
                    onHide={hideModal}
                    container={this}
                    aria-labelledby="contained-modal-title"
                    centered
                    //size="lg"
                    ref={dialogRef}
                   
                  >
                    <form onSubmit={formik.handleSubmit}>     
                    <Modal.Header closeButton>
                      <Modal.Title id="contained-modal-title">{t('workOrder.label.partFromBom')}</Modal.Title>
                    </Modal.Header>
                    <Modal.Body>
                                
                         <div className="row"> 
                                <div className="col-12">
                                  <div className="form-group">
                                    <label>{t('general.label.name')}</label>
                                    <input type="text" class="form-control" readOnly onClick={handleOpenArticleList} placeholder="" {...formik.getFieldProps('name')} />
                                  </div>
                                  {formik.touched.name && formik.errors.name ? (
                                    <div style={{ color: 'red' }}>{formik.errors.name}</div>
                                ) : null} 
                                </div>        
                          </div>
                          <div className="row">
                                <div className="col-6 col-sm-6 col-lg-6">
                                     <div className="form-group">
                                       <label>{t('workOrder.label.maxQty')}</label>
                                       <NumberFormat  displayType="text"  className="form-control col-12 col-sm-12 col-lg-12" decimalScale="2" style={{ background: '#E9ECEF' }}  thousandSeparator="." decimalSeparator="," suffix={' '+loadedMeasureUnit ? loadedMeasureUnit : ''}  value={maxQty}  />                                                                               
                                     </div>
                                </div>
                          </div>



                          <div className="row">
                                <div className="col-6 col-sm-6 col-lg-6">
                                     <div className="form-group">
                                       <label>{t('document.label.qty')}</label>
                                       <NumberFormat displayType='input' className="form-control col-12 col-sm-12 col-lg-12" decimalScale="2" thousandSeparator="." decimalSeparator=","  suffix={' '+loadedMeasureUnit ? loadedMeasureUnit : ''}  value={qty} onValueChange={(values)  => {handleChange(values,"qty")}} />                                                                                     
                                     </div>
                                </div>
                             
                          </div>

                               <div className="row">

                                  <div className="col-3 col-sm-3 col-lg-3">
                                        <div className="form-group">
                                            <label>{t('partner.label.validFrom')}</label>                                                                               
                                            <DatePicker
                                                readOnly
                                                className='form-control'                                            
                                                selected={validFromLong}
                                                onChange={(value) => setValidFromLong(new Date(value).getTime())}
                                                dateFormat="dd.MM.yyyy"                                                                                                                                
                                            />                                                   						
                                        </div>
                                  </div>        


                                  <div className="col-3 col-sm-3 col-lg-3">
                                        <div className="form-group">
                                            <label>{t('partner.label.validTo')}</label>                                                                               
                                            <DatePicker
                                                readOnly
                                                className='form-control'                                            
                                                selected={validToLong}
                                                onChange={(value) => setValidToLong(new Date(value).getTime())}
                                                dateFormat="dd.MM.yyyy"                                                                                    
                                            />                                                   						
                                        </div>
                                  </div>   

                          </div>                                

                    </Modal.Body>
                    <Modal.Footer>                          
                          <Button style={selectedRecord ? {} : { display: 'none' }} className="btn-danger" onClick={deleteRecord}>{t('general.button.delete')}</Button>    
                          <Button style={operationId ? {} : { display: 'none' }} className="btn-primary" type="submit">{t('general.button.save')}</Button>    
                          <Button className="btn-default" onClick={hideModal}>{t('general.button.cancel')}</Button>
                    </Modal.Footer>
                    </form>  
                                        
                  </Modal>                                      
                </div>
               
                <AlertDialog
                open={openAlertDialog}
                message={t('general.message.areYouSure')}
                header={t('general.message.confirmDelete')}
                parentCallback={handleAlertDialogCallback}
                ></AlertDialog> 

          <ArticlePartModalWithDatatable        
            parentCallback={handleCallback}    
            modal={showArticlePartModalWithDatatable}   
            bomId={bomId}                             
          />
      </>
    );
  };

 export default UsedBomModal;